import { render, staticRenderFns } from "./DepartmentOrderTable.vue?vue&type=template&id=9cb65204"
import script from "./DepartmentOrderTable.vue?vue&type=script&lang=js"
export * from "./DepartmentOrderTable.vue?vue&type=script&lang=js"
import style0 from "./DepartmentOrderTable.vue?vue&type=style&index=0&id=9cb65204&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports